import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../assets/styles/Banner.css";
import { BaseUrl } from "../config/api";

const Banner = () => {
  const [bannerImages, setBannerImages] = useState([]);

  useEffect(() => {
    const fetchBannerImages = async () => {
      try {
        const response = await fetch(`${BaseUrl}/marketing`);
        const data = await response.json();
        setBannerImages(data);
      } catch (error) {
        console.error("Error fetching banner images:", error);
      }
    };

    fetchBannerImages();
  }, []);

  const settings = {
    dots: true,
    infinite: true,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
  };

  const handleShopNowClick = () => {
    document.querySelector(".category-section").scrollIntoView({
      behavior: "smooth",
    });
  };

  return (
    <div className="banner">
      <Slider {...settings}>
        {bannerImages.map((banner, index) => (
          <div key={banner._id} className="banner-slide">
            <div className="banner-content">
              <img
                src={banner.imageUrls[0]}
                alt={`Banner ${index + 1}`}
                className="banner-image"
              />
              {index === 1 && (
                <div className="banner-text">
                  <h1>
                    Fabric that's Match
                    <br />
                    your personality
                  </h1>
                  <button className="shop-now-btn" onClick={handleShopNowClick}>
                    Shop Now
                  </button>
                </div>
              )}
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default Banner;
